import {
  fetchDataPending,
  fetchDataSuccess,
  fetchDataError
} from './../bodyConditionAction';
import fetchApi from "./fetchApi";

function fetchBodyConditionAction() {
  return fetchApi('/v1/fc_api/body_condition_resource', fetchDataPending, fetchDataSuccess, fetchDataError);
}

export default fetchBodyConditionAction;
